<template lang="pug">
  .wrap
    page-title Recognitions

    template(v-if='!showPlaceholder' v-loading='loading')
      list-header(:on-search='search')
        div(slot='action')
          el-button(v-if='list.count' @click='requestPdfExport' :loading='requestingExport') Export as PDF

      .list(v-if='list.count')
        .item(v-for='rec in list.results' :key='rec.id')
          .item-pic
            img(v-if='rec.imageFullUrl' :src='getThumbUrl(rec.imageFullUrl)')
          .item-main
            .item-header
              .item-reported {{ rec.reportedUserName }}
              .item-location {{ rec.location }}

              .item-stars
                icon.item-star(v-for='n in fullStars(rec)' :key='n' name="star" color='gold')
                icon.item-star(v-for='n in emptyStars(rec)' :key='n' name="star" color='lightgrey')

            .item-details {{ rec.details }}
      .no-results(v-else) No results found.

      .pages
        el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')

    .empty(v-else)
      recognition-list-empty

</template>

<script>
import { mapActions } from "vuex";
import format from "date-fns/format";
import _ from "lodash";
import thumbUrl from "@/shared/utils/thumbUrl";
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";
import RecognitionListEmpty from "../RecognitionListEmpty";

export default {
  components: { PageTitle, RecognitionListEmpty, ListHeader },
  data() {
    return {
      loading: true,
      pageSize: 20,
      searchParams: null,
      requestingExport: false,
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    showPlaceholder() {
      return !this.loading && !this.list.count && !this.searchParams;
    }
  },
  methods: {
    ...mapActions("recognitions", ["fetchRecognitions", "generatePdfExport"]),
    loadList({ params } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        ...params
      };
      this.loading = true;
      this.fetchRecognitions({ params: mergedParams }).then(data => {
        this.loading = false;
        this.list = data;
      });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    },
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: { q } });
    },
    navigateToEdit(recognitionId) {
      this.$router.push({ name: "recognitionEdit", params: { recognitionId } });
    },
    formattedDate(date) {
      return format(date, "D MMM h:mm a");
    },
    getThumbUrl(url) {
      return thumbUrl(url, 1000, 500);
    },
    fullStars(rec) {
      return _.range(rec.rating);
    },
    emptyStars(rec) {
      return _.range(5 - rec.rating);
    },
    requestPdfExport() {
      this.requestingExport = true;
      this.generatePdfExport()
        .then(() => {
          this.requestingExport = false;
          this.$message({
            message:
              "We're generating your PDF file, you will receive an email soon as it is ready.",
            type: "success",
            duration: 0,
            showClose: true
          });
        })
        .catch(err => {
          this.requestingExport = false;
          this.$message.error(
            "There's been a problem generating your report, please try again shortly."
          );
          throw err;
        });
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/scss/mixins.scss";
.list {
  display: flex;
  flex-wrap: wrap;
}

.item {
  flex: 0 1 calc(50% - 10px);
  margin: 0 10px 10px 0;
  display: flex;
  flex-direction: row;
  background: white;

  &:nth-child(2) {
    margin-right: 0;
  }
  @include MQ(M) {
    flex-basis: 100%;
    margin: 10px 0 0 0;
  }
}

.item-pic {
  flex: 0 0 200px;
  img {
    width: 100%;
  }
  @include MQ(L) {
    flex-basis: 150px;
  }
}

.item-main {
  padding: 10px;
  flex: 1;
  margin: 10px 0 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.item-reported {
  font-size: 24px;
  margin-bottom: 5px;
  font-family: "gilroylight";
}

.item-location {
  font-weight: normal;
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 12px;
  margin-bottom: 10px;
}

.item-stars {
  margin-bottom: 5px;
}

.item-star {
  margin-right: 3px;
}

.item-details {
  font-size: 13px;
  color: #666;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  padding: 80px 0;
  flex-direction: column;
}

.emptystate {
  width: 100%;
}

.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-results {
  font-size: 30px;
  color: #666;
  padding: 30px 0;
  text-align: center;
}
</style>
